export const sendUXSEvent = (name: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (typeof window !== 'undefined' && (window as any).UXS) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).UXS.sendEvent(name);
  }
};
